export const routesMap = new Map([
    ['find', 'search-order'],
    ['results', 'search-results'],
    ['booking', 'checkout'],
    ['schedule', 'flights-schedule'],
    ['seats', 'select-seats'],
    ['baggage', 'select-baggage'],
    ['meal', 'select-meal'],
    ['passengers', 'travellers'],
    ['insurance', 'select-insurance'],
    ['order', 'review-order'],
    ['payment', 'payment']
]);
